import React, { Component } from 'react';

class StatList extends Component {
    render() {
        const { stats, onSelectStat, onNewStat } = this.props;

        return (
            <div className='admin_list'>
                <button onClick={onNewStat}>Create New Stat</button>

                {stats.map((stat, index) => (
                    <div className='listElement' key={index} onClick={() => onSelectStat(stat)}>
                        {stat.name}
                    </div>
                ))}

            </div>
        );
    }
}

export default StatList;
